import React, {useContext} from "react";
import styles from './ProjectStatsRow.module.scss';
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import {Money} from "../../../common";
import {formatPercents} from "../../../../formatters";
import {formatDate} from "../../../../formatters";
import {translatePaymentScheduleType} from "../../../../api-client";

const ProjectStatsRow = () => {
  const project = useContext(DetailedProjectContext).project;

  const items: Array<{ value: React.ReactNode; label: string }> = [
    {value: <Money money={project.accounting.loan}/>, label: 'Сумма сбора'},
    {value: formatPercents(project.accounting.interestRate, 0), label: 'Фикс. ставка'},
    {value: formatPercents(project.accounting.effectiveInterestRate, 0), label: 'Прогноз дохода'},
    {value: `${project.accounting.initialTerm} мес.`, label: 'Срок займа'},
    {
      value: project.scheduleType ? translatePaymentScheduleType(project.scheduleType) : '—',
      label: 'График платежей'
    },
    {value: formatDate(project.maturityDate), label: 'Сбор до'},
  ];

  return (
    <div className={styles.projectStatsRow}>
      {items.map((item) => (
        <div key={item.label} className={styles.projectStatsRow__item}>
          <div className={styles.projectStatsRow__value}>{item.value}</div>
          <div className={styles.projectStatsRow__label}>{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default ProjectStatsRow;
